"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prod = void 0;
var constants_1 = require("./constants");
exports.prod = {
    applicationEnvironment: {
        account: '741740907498',
        region: 'us-east-1',
    },
    persistence: {
        itemsTable: "prod-".concat(constants_1.ITEMS_TABLE),
        photosBucket: "jasonandfriends-prod-".concat(constants_1.PICTURES_BUCKET),
    },
};
